import tplLoader from "./tpl-loader.js";
import functions from './functions.js';
import { Calendar } from './calendar.js';
import { SimpleGuests } from "./simple-guests.js";
import { DetailsCart } from './details-cart.js';

const $window = $(window);

$(() => {
    details.init();

 
});

const details = {
    $form: null,
    form: null,
    calendars: [],
    params: {
        objectId: null,
        unitId: null,
        guests: '1,0',
        dates: null,
        dateFrom: null,
        dateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
    },
    cart: null,
    $transportation: null,
    inquiryRequired: ['dates', 'firstName', 'lastName', 'email', 'phone', 'guests'],
    focusOnBooking: false,
    calcTotal: 0,
    trackingTotal: 0,
    init() {

        if (!$('.page-type-details')[0]) {
            return;
        }
        let isMobile = functions.isMobile();

        if ($('#booking').attr('data-objectgroupid') != 6) return


        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');

        $(window).scroll(e => {
            const offset = $('#booking').offset().top - $('#booking').outerHeight();

            $(window).scrollTop() > 200
                ? $('.nav-top').addClass('visible')
                : $('.nav-top').removeClass('visible');


            $(window).scrollTop() > 200 && $(window).scrollTop() < offset
                ? $('.nav-bottom').addClass('visible')
                : $('.nav-bottom').removeClass('visible');


        });

       

        $(document).on('click', '[data-bs-toggle="modal"][data-bs-tab]', e => {
            const $target = $(e.currentTarget);
            const unitId = $target.attr('data-unitid');
            const $tab = $('#' + $target.attr('data-bs-tab') + '-link');
            $tab[0].click();
        });

        $('.btn-booking-align-bottom').on('click', function (e) {
            let wh = $(window).outerHeight();
            if (functions.isMobile()) functions.scrollToElement($('.booking-scroll-hook'), wh);
        })

        details.getParams();

        setTimeout(() => {
            if (details.params.booking)
            {
                details.params.booking = false;
                functions.scrollToElement('#booking', 50);
                functions.setUrlData(details.params, true, true);
            }
        }, 150);

        details.$transportation = $('.transportation');


        if (details.params.selectedUnitId && $('.booking-unit-card').length > 1)
        {
            $('.booking-unit-card[data-unitid="' + details.params.selectedUnitId + '"' ).addClass('selected');
            functions.scrollToElement($('.booking-unit-card[data-unitid="' + details.params.selectedUnitId + '"' ), 250);
        }

        if (isMobile && details.datesSelected()) 
        {
            $('.select-dates-nav-bottom').addClass('d-none');
            $('.book-now-nav-bottom').removeClass('d-none');
        }

        // if(details.params.calendar) functions.scrollToElement($('#booking'), 0);

        // let params = functions.getUrlData(true);
        // details.params.guests = params.guests;

        
        details.params.unitId = $('#booking').attr('data-unitid');
        details.params.objectId = $('#booking').attr('data-objectid') || null;

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if ($('[data-calendarconfig]').length) {
            details.calendarInit();
        }

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length && ! functions.isGlobalCartEnabled() ? new DetailsCart(this.params) : null;

        if (details.params.dateFrom && details.params.dateTo) {

            $('.datepicker-range-book').each((index, elem) => {

                $(elem)[0]._flatpickr && $(elem)[0]._flatpickr.setDate(details.params.dateFrom);
            });
 
            details.callbackOnDatesSelected(details.params.dateFrom);
        }

        if (details.params.guests && $('.simple-guests')[0]) {
            $('.simple-guests').each((index, elem) => {
                elem._simpleGuests.setValue(details.params.guests);
            });
        }

        details.getCalculation();

        details.$transportation && (
            details.$transportation.find('input').on('change', e => {
                let checked = $(e.currentTarget).is(':checked');
                let $price = $('.price');
                let price = $price.html().replace('€ ', '');
                let transportationPrice = +details.$transportation.find('[data-price]').attr('data-price');

                // $price.html('€ ' + (+price + ((transportationPrice) * (checked ? 1 : -1)) ));

                let $addToCart = $('.add-to-cart');
                if (checked) {
                    $addToCart.attr('href', $addToCart.attr('href') + '&transportation=1&transportationPrice=' + transportationPrice);
                } else {
                    $addToCart.attr('href', $addToCart.attr('href').replace('&transportation=1&transportationPrice=' + transportationPrice, ''));
                }

            })
        )


        $('[name="dates"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.dateFrom = details.params.dateTo = $target.val();
            if (details.params.dateFrom && details.params.dateTo) {
                details.focusOnBooking = true;
                $('.dates-clear').removeClass('d-none');
                $('.nav-bottom').removeClass('visible');
                $('.select-dates-nav-bottom').addClass('d-none');
                $('.book-now-nav-bottom').removeClass('d-none');
            }
            else
            {
                $('.dates-clear').addClass('d-none');
                e.stopPropagation();
            }
            functions.setUrlData(details.params, true, true);

            let $parent = $(e.currentTarget).parents('[data-calendarconfig]');
            let calendarId = $parent.attr('data-calendar-index');

            details.calendars.forEach((elem, index) => {
                if (index == calendarId) return;
                details.calendars[index].setDate(details.params.dateFrom)
            })
           
        });

        $('.dates-clear').on('click', function(e) {
            // $('.dates-clear').addClass('d-none');
            $('.datepicker-range')[0] && $('.datepicker-range')[0]._flatpickr.setDate([])
            $('.datepicker-range-book')[0] && $('.datepicker-range-book')[0]._flatpickr.setDate([])
            $('[name="dates"]')[0]._flatpickr && $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true, true);
            $('.total-converted').addClass('d-none');
            $('.total-converted-default').removeClass('d-none');
            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);

            $('.btn-booking').addClass('d-none');
            $('.calculation').addClass('d-none');

            $('.calc-msg').addClass('d-none');

            $('.label-from').removeClass('d-none');
            $('.label-total').addClass('d-none');

            $('.no-calculation').removeClass('d-none');
            $('.calculation-text').addClass('d-none');

            // ['.price-old', '.price', '.price-old-converted', '.price-converted'].forEach((elem, i) => {
            //     let $elem = $(elem);
            //     if ($elem.length) {
            //         let curr = $elem.attr('data-currency');
            //         let price = $elem.attr('data-price');
            //         if (price && price !== '0,00' && price !== '0') {
            //             let formatedPrice = curr + ' ' + price;
            //             if (i < 2) formatedPrice = price + ' ' + curr;
            //             $elem.html(formatedPrice);
            //         }
            //         else {
            //             $elem.html('');
            //         }
            //     }
            // })
            e.stopPropagation();
        })

        $('[name="guests"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.guests = $target.val();
            functions.setUrlData(details.params, true, true);
        });
        

        $(window).on('hashchange', e => {
            details.getParams();
            if ($('[data-calendarconfig]')[0]) {
                details.getCalculation()
            }
            // details.getCalculation();
        });

        $('.unit-search-form').on('submit', function(e) 
        {
            e.preventDefault();
            details.getCalculation();
        })

        details.loadReviews();
        details.inquiryInit();

        if (details.cart) 
        {
            let $btnBooking = this.cart ? $('.btn-cart-booking') : null;
            $btnBooking.length && $btnBooking.on('click', e => {
                e.preventDefault();
                let cartData = [];

                this.cart.cartItems.forEach(item => {
                    item = JSON.parse(item);
                    cartData.push({
                        'unitId': item.unitId,
                        'dateFrom': item.dateFrom,
                        'dateTo': item.dateTo,
                        'guests': item.guests,
                        'transportation': item.transportation || false,
                    }); 
                });
                let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&cart_mode=1';
                if(this.cart.cartItems.length) {
                    location = url;
                } else {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }


    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = +$button.data('total');

            $.post('/services/reviews/', { language: functions.getLang(), perPage: perPage, page: page, 
                unitId: $button.attr('data-unitId') || undefined, 
                objectId: $button.attr('data-objectId') || undefined
             }).then(response => {
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= (page * perPage)) {
                        $button.addClass('d-none');
                    }
                    console.log($button.parent().siblings(".reviews-list"));
                    $button.parent().siblings(".reviews-list").append(response.html);
                }
            });
        });
    },
    calendarInit() {

        $('[data-calendarconfig]').each((index, $elem) => {

            let config = JSON.parse($($elem).attr('data-calendarconfig'));

            let defaultDate = $($elem).attr('data-defaultdate');
            let minDate = $($elem).attr('data-mindate');
            /*if( ! details.params.dateFrom && defaultDate) {
                let dates = defaultDate.split(' - ');
                //details.params.dates = defaultDate;
                details.splitCalendarDates(defaultDate);
                defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
            }*/
            let months = 3;
            if (config && config.showMonths) months = config.showMonths;
            details.calendars[index] = new Calendar(
                $($elem).find('.datepicker-range-book'),
                {
                    availabilityMask: config.availabilityMask,
                    startDate: config.startDate,
                    minStay: config.minStay,
                    periods: config.periods,
                    translations: config.translations,
                    defaultDate: defaultDate ? defaultDate : [],
                    minDate: minDate ? minDate : 'today',
                    mode: config.mode || 'single',
                    inline: config.inline || true,
                    showMonths: months,
                    containerClass: 'details-booking-calendar mx-auto'
                },
                details.callbackOnDatesSelectedUnit
            );

            $($elem).attr('data-calendar-index', index);
        });

        

        
    },
    inquiryInit() {
        let now = functions.cleanDate(new Date);
        let $datesI = null;
        $('.datepicker-range-inquiry').each((i, elem) => {
            const $datepicker = $(elem);
            const minDate = $datepicker.attr('data-min');
            const maxDate = $datepicker.attr('data-max');
            const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
            const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
            const duration = Number($datepicker.attr('data-duration'));
            const position = $datepicker.attr('data-position') || 'auto';
            const minStayText = $datepicker.attr('data-minstay');
            $datesI = $datepicker.flatpickr({
                mode: "single",
                showMonths: functions.isMobile() ? 2 : 1,
                altInput: true,
                wrap: true,
                altFormat: "j.m.Y",
                dateFormat: "Y-m-d",
                defaultDate: defaultDate,
                minDate: minDate && minDate >= now ? minDate : now,
                maxDate: maxDate ? maxDate : null,
                disableMobile: true,
                prevArrow: '<i class="la la-arrow-left la-fw la-2x pr-2"></i>',
                nextArrow: '<i class="la la-arrow-right la-fw la-2x pl-2"></i>',
                locale: {
                    rangeSeparator: ' - '
                },
                position: position,
                minStayText: minStayText ? minStayText : '',
                onDayCreate(dObj, dStr, fp, dayElem) {

                    let minStay = 1;
                    let to = new Date(maxDate);
                    let weekday = new Date(dayElem.dateObj).getDay();
                    weekday = '' + (weekday ? weekday : 7);
                    to.setHours(0, 0, 0, 0);
                    let onlyCheckInSelected = fp.selectedDates[0] && !fp.selectedDates[1];
                    // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                    let from = dayElem.dateObj;
                    let too = fp.selectedDates[0];
                    // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
                    // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());

                    let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

                    if (onlyCheckInSelected) {
                        if (Math.abs(diff) < minStay) {
                            dayElem.className += ' flatpickr-disabled ';
                            if (diff) {
                                if (minStayText) {
                                    $(dayElem).tooltip({
                                        title: minStayText.replace('{$min_stay}', minStay) || ''
                                    });
                                }
                            }
                        }
                    }

                    if (dayElem.dateObj > to || (arrival.length && $.inArray(weekday, arrival) == -1)) {
                        dayElem.classList.add('unselectable');
                    }
                },
            });
            // to style clear toggler
            $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
        });

        $('form#inquiry').on('submit', e => {
            e.preventDefault();


            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $(e.currentTarget).serializeArray();
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });

            params['dates'] = params.datesi || '';

            params['dates'] = params['dates'] + ' - ' + params['dates'];

            if (!params.dates) {
                $datesI.open();
                $('.contact-btn').removeClass('d-none');
                $('.contact-spinner').addClass('d-none');
                $('.contact-spinner').removeClass('d-flex');
                return;
            }

            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {
                        response.status ? $('.request-success').html(response.data).removeClass('d-none') 
                            : $('.request-error').html(response.data).removeClass('d-none');

                        $('.contact-spinner').addClass('d-none');
                        $('.contact-spinner').removeClass('d-flex');
                        setTimeout(() => {
                            $('.contact-btn').removeClass('d-none');
                            
                            $(".request-error, .request-success").addClass('d-none');
                        }, 7000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });
    },
    callbackOnDatesSelected(from, to) 
    {
        if (to && !to[1]) {
            $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({ message: !from ? 'selectDates' : 'selectDepartureDate' }));
            $('.btn-booking').addClass('d-none');
        }
    },
    callbackOnDatesSelectedUnit(from, to) 
    {
        if(from && to && $('.datepicker-range')[0]) $('.datepicker-range')[0]._flatpickr.setDate([from, to]);
    },
    splitCalendarDates(dates) {
        console.log(dates);
        if (dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    isRequest(data) {
        return !data.isAvailable && data.calc.status == 'Request';
    },
    getCalcErrorMessage(data) {
        if (data.message && details.calcErrorMessages && details.calcErrorMessages[data.message]) {
            return details.calcErrorMessages[data.message].replace('{$condition}', data.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    datesSelected() {
        return details.params.dateFrom && details.params.dateTo;
    },
    getCalculation(unitId = null) {

        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;

        if (
            (details.params.objectId || unitId)
            && details.params.guests
            && dateFrom
            && dateTo
            && details.params.objectGroupId
        ) {
            $('.calendar-wrapper').addClass('pe-none');
            $('.calc-loader').prepend(tplLoader).scrollTop(0);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');
            $('.calc-msg').addClass('d-none').html('');

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId && ! details.cart ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateFrom
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
                + '&addAllOptionals=' + 1
            )
                .done(response => {

                    if (response.status) {
                        const data = response.data || [];

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];
                            const $unit = $('.booking-unit-card[data-unitid=' + unitId + ']');
                            details.$transportation.find('input').prop('checked', false);

                            const $addToCart = $unit.find('.add-to-cart');
                            const $btnBooking = this.cart ? $('.btn-cart-booking') : $unit.find('.btn-booking');

                            let notInCart = null;

                            notInCart =  this.cart && details.cart.cartItems.some(function (item) {
                                item = JSON.parse(item);

                                if (item.unitId != unitId) return false;

                                if (item['dateFrom'] <= details.params.dateFrom && details.params.dateFrom <= item['dateTo']) return true; // b starts in a
                                if (item['dateFrom'] <= details.params.dateTo   && details.params.dateTo   <= item['dateTo']) return true; // b ends in a
                                if (details.params.dateFrom <  item['dateFrom'] && item['dateTo']   <  details.params.dateTo) return true; // a in b

                                return false;
                            });

                            if (functions.isGlobalCartEnabled()) notInCart = window.globalCart.isUnitWithPeriodInCart(details.params, unitId);

                            if (details.isBookable(unitData) && ! notInCart) {
                                const unitCalc = unitData.calc;

                                const calcItems = unitCalc.items;
                                let priceOld = 0.00;
                                let priceOldEUR = 0.00;
                                let discountTitle = null;

                                calcItems.forEach(item => {
                                    // popust za djecu ne ulazi u prikaz discount cijene
                                    if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                        priceOld += item.itemTotal;
                                        priceOldEUR += item.itemTotalEUR;
                                    }
                                    if (item.itemType == 'discount') {
                                        discountTitle = item.itemTitle;
                                        if (item.data && item.data.text) {
                                            discountTitle = item.data.text;
                                        }
                                    }
                                });

                                let transportationItem = calcItems.filter(item => {
                                    return item.itemDefinitionId == 115;
                                })[0] || null;

                                details.transportation(transportationItem);

                                details.calcTotal = unitCalc.total;

                                const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                                const priceOldFormated = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                                const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',') + ' kn';
                                const priceOldEURFormated = functions.formatMoney(priceOldEUR, 0, '.', ',') + ' kn';


                                let unitTitle = $unit.find('.unit-title').text();

                                $addToCart.attr('data-unittitle', unitTitle);
                                $addToCart.attr('data-unitcarttotal', unitCalc.total);
                                $addToCart.attr('data-unitcarttotalold', priceOld);
                                $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);

                                $addToCart.attr('data-unitid', unitId);
                                $addToCart.attr('data-datefrom', this.params.dateFrom);
                                $addToCart.attr('data-dateto', this.params.dateTo);
                                $addToCart.attr('data-guests', this.params.guests);

                                $addToCart.removeClass('d-none');

                                $unit.find('.price').removeClass('d-none');

                                if (! details.cart)
                                {
                                    if($btnBooking.attr('href')) {
                                        let cartItem = {
                                            'unitId': unitId,
                                            'dateFrom': details.params.dateFrom,
                                            'dateTo': details.params.dateTo,
                                            'guests': details.params.guests,
                                        }
                                        $btnBooking.attr('href',
                                            $btnBooking.attr('href').split('?')[0] +
                                            '?cart_data=' + JSON.stringify([cartItem]) + '&addAllOptionals=true&cart_mode=1'
                                        );
                                    $btnBooking.removeClass('d-none');

                                    }
                                }

                                if (functions.isGlobalCartEnabled())
                                {
                                    if($addToCart.attr('href')) {
                                        $addToCart.attr('href',
                                            $addToCart.attr('href').split('?')[0] +
                                        '?unitId=' + unitId +
                                        '&dateFrom=' + details.params.dateFrom +
                                        '&dateTo=' + details.params.dateTo +
                                        '&guests=' + details.params.guests +
                                        '&price=' + unitCalc.total +
                                        '&addAllOptionals=' + 1
                                        );
                                        $addToCart.removeClass('d-none');
                                    }

                                    if($btnBooking.attr('href')) {
                                        let cartItem = {
                                            'unitId': unitId,
                                            'dateFrom': details.params.dateFrom,
                                            'dateTo': details.params.dateTo,
                                            'guests': details.params.guests,
                                        }
                                        $btnBooking.attr('href',
                                            $btnBooking.attr('href').split('?')[0] +
                                        '?cart_data=' + JSON.stringify([cartItem]) + '&cart_mode=1' +
                                        '&addAllOptionals=' + 1
                                        );

                                    }
                                }

                                let guestsText = unitCalc.guests.split(',', 2);
                                guestsText = guestsText.reduce((sum, num) => sum + +num, 0);

                                $btnBooking.removeClass('d-none');
                                $unit.find('.price-wrap').removeClass('d-none');
                                $unit.find('.alt-dates').addClass('d-none').html('');
                                $unit.find('.in-cart').addClass('d-none');
                                $unit.find('.added-to-cart').addClass('d-none');

                                $unit.find('.label-from').addClass('d-none');

                                $unit.find('.c  ').addClass('d-none');

                                $unit.find('.price').html(total);

                                if (+Math.floor(priceOld) > +Math.floor(unitCalc.total))
                                    {
                                    $unit.find('.price-old').html(priceOld && priceOld > unitCalc.total ? priceOldFormated : '').removeClass('d-none');
                                    $unit.find('.price-converted').html(totalEUR).removeClass('d-none');
                                    $unit.find('.price-old-converted').html(priceOld && priceOld > unitCalc.total ? priceOldEURFormated : '').removeClass('d-none');
                                }
                                else
                                {
                                    $unit.find('.price-converted').addClass('d-none');
                                    $unit.find('.price-old').addClass('d-none');
                                    $unit.find('.price-old-converted').addClass('d-none');

                                }

                                $unit.find('.label-total').removeClass('d-none');

                                $unit.find('.no-calculation').addClass('d-none');
                                $unit.find('.calculation').removeClass('d-none');
                                $unit.find('.booking-guests').html(guestsText);
                                $unit.find('.booking-nights').html(unitCalc.nights);
                                $unit.find('.booking-period').html(functions.formatDate(details.params.dateFrom, 'dd.mm.yyyy.') + ' - ' + functions.formatDate(details.params.dateTo, 'dd.mm.yyyy.'));

                            } else {

                                if (notInCart) $unit.find('.in-cart').removeClass('d-none');
                                if (['minOccupancy', 'maxOccupancy'].includes(unitData.message)) $unit.find('.calc-msg').removeClass('d-none').html(details.getCalcErrorMessage(unitData));
                                

                                if (! details.cart && ! functions.isGlobalCartEnabled()) $unit.find('.calc-msg').removeClass('d-none').html(details.getCalcErrorMessage(unitData));
                                // $btnBooking.addClass('d-none');

                                

                                $unit.find('.label-from').removeClass('d-none');
                                $unit.find('.label-total').addClass('d-none');
                                $unit.find('.added-to-cart').addClass('d-none');
                                $addToCart.addClass('d-none');

                                $unit.find('.no-calculation').addClass('d-none');
                                $unit.find('.calculation').addClass('d-none');
                                $unit.find('.price-wrap').addClass('d-none');
                                $unit.find('.price').addClass('d-none');


                                // ['.price-old', '.price', '.price-old-converted', '.price-converted'].forEach((elem, i) => {
                                //     let $elem = $unit.find(elem);
                                //     if ($elem.length) {
                                //         let curr = $elem.attr('data-currency');
                                //         let price = $elem.attr('data-price');
                                //         if (price && price !== '0,00' && price !== '0') {
                                //             let formatedPrice = curr + ' ' + price;
                                //             if (curr == 'kn') formatedPrice = price + ' ' + curr;
                                //             $elem.html(formatedPrice);
                                //         }
                                //         else {
                                //             $elem.html('');
                                //         }
                                //     }
                                // })
                            }

                            setTimeout(() => {
                                let wh = $(window).outerHeight();
                                $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                                $('.calendar-wrapper').removeClass('pe-none');
                                $('.calc-wrapper').css('opacity', 1);
                                $('.calc-wrapper').css('display', 'flex');
                                // if (functions.isMobile() && details.focusOnBooking) functions.scrollToElement($('.booking-scroll-hook'), wh);
                            }, 450)


                        });
                    }

                }).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.price-wrap').removeClass('d-none');
            $('.alt-dates').addClass('d-none').html('');
            $('.in-cart').addClass('d-none');
            $('.btn-booking').addClass('d-none');
            $('.add-to-cart').addClass('d-none');
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');
            $('.added-to-cart').addClass('d-none');
            $('.calc-message').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.total-old').toggleClass('d-none', !$('.total-old').attr('data-minPriceHasDiscount'));
            $('.total-old').text($('.total-old').attr('data-minPriceHasDiscount') ? $('.total-old').attr('data-minPriceOld') : '');

        }
    },
    transportation(item = null) {
        if (! item) {
            details.$transportation.addClass('d-none');
            return;
        }

        details.$transportation.removeClass('d-none');
        details.$transportation.find('[data-price]').attr('data-price', item.itemTotal).html("€ " + item.itemTotal);
    },

}
